import React, { Component } from 'react';
import { Link } from 'react-router';
import SkillStore from '../../stores/SkillStore';
import SkillActions from '../../actions/SkillActionCreator';

class SkillStat extends  Component {

    constructor() {
        super(...arguments);
        this.state = {
            details: {
                id: '',
                name: '',
                description: '',
                criteria: '',
                validFrom: '',
                validTo: '',
                lifetime: '',
                listOrder: '',
                status: '',
                type: '',
                level: '',
                trainer: '',
                group: '',
                code: '',
                certificate: '',
                sysStatus: '',
            },

        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        SkillStore.addChangeListener(this.onChange);
        SkillActions.getById(this.props.skillId);
    }

    componentWillUnmount() {
        SkillStore.removeChangeListener(this.onChange);
    }

    render() {

        let level1 = <div/>;
        let level2 = <div/>;
        let level3 = <div/>;
        const trainer = (this.state.details.trainer > 0 ? ' trainer' : '');

        switch(this.state.details.level) {

            case 'entry level':
                level1 = (<div className={`active${trainer}`} />);
                break;

            case 'intermediate':
                level1 = (<div className={`active${trainer}`} />);
                level2 = (<div className={`active${trainer}`} />);
                break;

            case 'advanced':
                level1 = (<div className={`active${trainer}`} />);
                level2 = (<div className={`active${trainer}`} />);
                level3 = (<div className={`active${trainer}`} />);
                break;

            default:
                break;
        }

        return (
                <div>
                    <h4>
                    <Link to={`/dashboard/skill/${this.state.details.id}`} >
                        {this.state.details.name}
                    </Link>
                    </h4>
                    <div className="skill-levels">
                        {level1}
                        {level2}
                        {level3}
                    </div>
                   <h5>{this.state.details.level}</h5>
                </div>
        )
    }

    onChange(){
        const details = SkillStore.getById(this.props.skillId);
        if (details !== undefined) {
            this.setState({details: details});
        }
    }

}

export default SkillStat;
